<script setup>
import {useBaseStore} from "~/stores/base";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["deleted"])

/** props **/
const props = defineProps({
  voteData: {default: {}}
})

/** data **/
const isShowModalDeleteConfirm = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="module-vote-item-skeleton-mobile" v-if="isMobile">
    <div class="product">
      <div class="cover-image-skeleton"></div>
    </div>
    <div class="records">
      <div class="skeleton-loader"></div>
      <div class="skeleton-loader"></div> <!-- Second skeleton loader -->
      <div class="skeleton-loader"></div> <!-- Third skeleton loader -->
    </div>
  </div>
  <div class="module-vote-item-skeleton-desktop" v-else>
    <div class="product">
      <div class="cover-image-skeleton"></div>
    </div>
    <div class="records">
      <div class="skeleton-loader"></div>
      <div class="skeleton-loader"></div> <!-- Second skeleton loader -->
      <div class="skeleton-loader"></div> <!-- Third skeleton loader -->
    </div>
  </div>
</template>

<style>
/* Define loader colors as variables */
:root {
  --loader-background-color: #EEEEEE;
  --loader-highlight-color: #DEDEDE;
}
</style>

<style scoped lang="scss">
@import "src/assets/config";

.module-vote-item-skeleton-mobile {
  width: 100%;
  border: 0.5px solid $color-BNTO-beige-dark;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  text-align: center;

  .product {
    width: 100%;
    display: flex;
    align-items: center;

    .cover-image-skeleton {
      width: 100%;
      padding-bottom: 20%;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  .records {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .skeleton-loader {
      width: 100%;
      height: 37.25px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}

.module-vote-item-skeleton-desktop {
  width: 100%;
  height: 100%;
  border: 0.5px solid $color-BNTO-beige-dark;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  text-align: center;

  .product {
    width: 100%;
    display: flex;
    align-items: center;

    .cover-image-skeleton {
      width: 100%;
      height: 74px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  .records {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .skeleton-loader {
      width: 100%;
      height: 37.25px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
